import React from 'react';
import { Redirect } from 'react-router-dom';
import basePath from 'utils/basePath';

const OverviewPageRoutes = (
  <Redirect
    from={`${basePath}/overview/:country?/:city?`}
    to={`${basePath}/s/:country?/:city?`}
  />
);

export default OverviewPageRoutes;
